import { render } from "./Potus.vue?vue&type=template&id=4c77a701"
import script from "./Potus.vue?vue&type=script&lang=js"
export * from "./Potus.vue?vue&type=script&lang=js"
script.render = render

export default script